export const blockIconsDeviceNoteAlt = (
	<span className='material-symbols-outlined'>note_alt</span>
);
